import dynamic from "next/dynamic";
import Link from "next/link";

import useSortQueryParam from "@/hooks/useSortQueryParam";

const Dropdown = dynamic(() => import("@/components/botanic/Dropdown"), {
  ssr: true,
});

/* eslint-disable sort-keys-fix/sort-keys-fix -- order matters */
const SORT_TEXT: {
  [key: string]: { label: string; params: { order: string; sort: string } };
} = {
  distance_asc: {
    label: "Distance",
    params: { order: "asc", sort: "distance" },
  },
  price_asc: {
    label: "Price: low to high",
    params: { order: "asc", sort: "price" },
  },
  price_desc: {
    label: "Price: high to low",
    params: { order: "desc", sort: "price" },
  },
  thc_display_asc: {
    label: "THC: low to high",
    params: { order: "asc", sort: "thc_display" },
  },
  thc_display_desc: {
    label: "THC: high to low",
    params: { order: "desc", sort: "thc_display" },
  },
  review_rating_desc: {
    label: "Rating",
    params: { order: "desc", sort: "review_rating" },
  },
  review_count_desc: {
    label: "Review Count",
    params: { order: "desc", sort: "review_count" },
  },
};
/* eslint-enable sort-keys-fix/sort-keys-fix */

const Sort: React.FC = () => {
  const {
    appliedSort,
    utils: { getUrlWithNewSort, getUrlWithoutSort },
  } = useSortQueryParam();

  let selectedItem = "recommended"; // * Default

  if (appliedSort) {
    const key = Object.keys(appliedSort)[0];
    const value = appliedSort[key];
    selectedItem = `${key}_${value}`;
  }

  return (
    <div
      data-testid="sort-dropdown"
      className="flex shrink-0 items-center justify-center ml-lg"
    >
      <Dropdown
        label="Sort by"
        variant="small"
        preselectedOption={selectedItem}
        options={["recommended", ...Object.keys(SORT_TEXT)]}
        onItemRender={(option) => ({
          as: Link,
          children: SORT_TEXT[option]?.label || "Recommended",
          href:
            option === "recommended"
              ? getUrlWithoutSort()
              : getUrlWithNewSort(
                  SORT_TEXT[option].params.sort,
                  SORT_TEXT[option].params.order,
                ),
        })}
      ></Dropdown>
    </div>
  );
};

export default Sort;
